<script lang="ts">
  import Authorization from "@shared/svelte/Components/Authorization.svelte";
  import { Icon, MenuLink } from "@getprovi/craft";

  import { EventTracking } from "@shared/services/event_tracking/events";

  import { LinkEntity } from "@shared/services/event_tracking/entities";
  import { SideMenuLinkEntity } from "@shared/services/event_tracking/entities";
  import type { SideMenuLink } from "@shared/types/SideMenuLink";

  export let closeMenu: () => void;
  export let link: SideMenuLink;

  const { trackClick, trackEvent } = EventTracking;

  const handleClick = (label: string): void => {
    trackClick("side_menu_link", [new SideMenuLinkEntity({ label })]);

    if (label === "Rep Recommendations") {
      trackEvent("click_rep_recommendations_menu_item", [
        new LinkEntity({ forward_url: "/rep_recommendations" }),
      ]);
    }

    if (label === "Lists") {
      trackClick("main_hamburger_menu_lists");
    }
    closeMenu();
  };
</script>

{#if link.authName && link.shouldShow !== false}
  <Authorization authName={link.authName}>
    <MenuLink
      href={link.href}
      external={link.external}
      title={link.title}
      subtitle={link.subtitle}
      on:click={() => {
        handleClick(link.title);
      }}
    >
      <Icon iconName={link.iconName} color="brand" size="icon-sm" slot="icon" />
    </MenuLink>
  </Authorization>
{:else if link.shouldShow !== false}
  <MenuLink
    href={link.href}
    external={link.external}
    title={link.title}
    subtitle={link.subtitle}
    on:click={() => {
      handleClick(link.title);
    }}
  >
    <Icon iconName={link.iconName} color="brand" size="icon-sm" slot="icon" />
  </MenuLink>
{/if}
